import React from 'react';
import { TextField, Grid } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { endOfDay, startOfDay } from 'date-fns';
import StateSelect from 'components/form/state_select';
import DatePicker from 'components/form/date_picker';
import UserAutocomplete from 'components/form/autocomplete/user';
import Form from 'components/filter/from';

const FilterForm = ({ initialValues, defaultValues, processing, onSubmit, onClose }) => {
  const intl = useIntl();

  return (
    <Form
      header={<FormattedMessage id="header.inspection.filter" />}
      processing={processing}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      contentRenderer={(formik) => (
        <>
          <TextField
            fullWidth
            autoFocus
            margin="dense"
            id="name"
            name="name"
            label={intl.formatMessage({ id: 'name' })}
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.name && Boolean(formik.errors.name)) || undefined}
            helperText={formik.touched.name && formik.errors.name}
          />
          <StateSelect
            fullWidth
            margin="dense"
            id="status"
            name="status"
            label={intl.formatMessage({ id: 'inspection.status' })}
            value={formik.values.status}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.status && Boolean(formik.errors.status)) || undefined}
            helperText={formik.touched.status && formik.errors.status}
          />
          <UserAutocomplete
            margin="dense"
            id="inspectorId"
            name="inspectorId"
            showNotAssigned={true}
            placeId={initialValues.placeId}
            setValue={formik.setFieldValue}
            label={intl.formatMessage({ id: 'inspector' })}
            value={formik.values.inspectorId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.inspectorId && Boolean(formik.errors.inspectorId)) || undefined}
            helperText={formik.touched.inspectorId && formik.errors.inspectorId}
          />
          <FormattedMessage className="margin-top-10" id="inspection.due_date" />
          <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
              <DatePicker
                className="full-width"
                id="dueDateFrom"
                label={intl.formatMessage({ id: 'filter.from' })}
                value={formik.values.dueDateFrom}
                onChange={(value) => formik.setFieldValue('dueDateFrom', startOfDay(value))}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <DatePicker
                className="full-width"
                name="dueDateTo"
                id="dueDateTo"
                label={intl.formatMessage({ id: 'filter.to' })}
                value={formik.values.dueDateTo}
                onChange={(value) => formik.setFieldValue('dueDateTo', endOfDay(value))}
              />
            </Grid>
          </Grid>
          <FormattedMessage className="margin-top-10" id="inspection.done_at" />
          <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
              <DatePicker
                className="full-width"
                id="doneAtFrom"
                label={intl.formatMessage({ id: 'filter.from' })}
                value={formik.values.doneAtFrom}
                onChange={(value) => formik.setFieldValue('doneAtFrom', startOfDay(value))}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <DatePicker
                className="full-width"
                name="doneAtTo"
                id="doneAtTo"
                label={intl.formatMessage({ id: 'filter.to' })}
                value={formik.values.doneAtTo}
                onChange={(value) => formik.setFieldValue('doneAtTo', endOfDay(value))}
              />
            </Grid>
          </Grid>
          <FormattedMessage className="margin-top-10" id="inspection.canceled_at" />
          <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
              <DatePicker
                className="full-width"
                id="canceledAtFrom"
                label={intl.formatMessage({ id: 'filter.from' })}
                value={formik.values.canceledAtFrom}
                onChange={(value) => formik.setFieldValue('canceledAtFrom', startOfDay(value))}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <DatePicker
                className="full-width"
                name="canceledAtTo"
                id="canceledAtTo"
                label={intl.formatMessage({ id: 'filter.to' })}
                value={formik.values.canceledAtTo}
                onChange={(value) => formik.setFieldValue('canceledAtTo', endOfDay(value))}
              />
            </Grid>
          </Grid>
        </>
      )}>
    </Form>
  );
};

export default FilterForm;
